// Import the Button component from this folder and send it down to ./components/index.js
import Input from './Input';

export default Input;